import React from 'react'
import { motion } from 'framer-motion'
import { Button } from '../ui/button'
import { Badge } from '../ui/badge'
import { ArrowRight, Sparkles } from 'lucide-react'
import { ImageWithFallback } from '../../utils/ImageWithFallback'
import { useNavigate } from 'react-router'

export function HeroComponent3() {
  const navigate = useNavigate()
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.2,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  }

  return (
    <section
      id="hero"
      className="relative h-screen flex items-center justify-center overflow-hidden "
    >
      {/* Full-width background image */}
      <div className="absolute inset-0 -z-10">
        <ImageWithFallback
          src="https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=1920&h=1080&fit=crop&q=80"
          alt="Lush green garden with modern landscaping"
          className="w-full h-full object-cover"
        />
        {/* Dark overlay for readability */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      <div className="relative z-10 text-white text-center max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.h2 variants={itemVariants}>
            <Badge className="bg-green-600/80 text-white border-green-500 mb-4 px-4 py-1.5 text-sm font-semibold backdrop-blur-sm">
              <Sparkles className="w-4 h-4 mr-2" />
              Creating Award-Winning Landscapes
            </Badge>
          </motion.h2>

          <motion.h1
            variants={itemVariants}
            className="text-4xl sm:text-6xl lg:text-7xl font-extrabold leading-tight mb-4 drop-shadow-lg"
          >
            Your Vision. Our Expertise.
            <span className="text-green-400 block mt-2">
              Perfectly Crafted.
            </span>
          </motion.h1>

          <motion.p
            variants={itemVariants}
            className="text-lg sm:text-xl text-gray-200 max-w-2xl mx-auto mb-8"
          >
            We specialize in transforming ordinary outdoor spaces into
            breathtaking, functional havens that reflect your unique style and
            needs.
          </motion.p>

          <motion.div
            variants={itemVariants}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Button
              size="lg"
              className="bg-green-500 hover:bg-green-600 text-white shadow-lg transition-colors px-8 py-3 text-lg group"
              onClick={() => {
                console.log('click')
                navigate('/contact')
              }}
            >
              Request a Free Quote
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-white/40 text-white hover:bg-white/10 transition-colors px-8 py-3 text-lg"
              onClick={() => navigate('/services')}
            >
              Explore Our Services
            </Button>
          </motion.div>
        </motion.div>
      </div>

      {/* Floating element for visual interest */}
      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <motion.div
            className="w-1 h-3 bg-white/70 rounded-full mt-2"
            animate={{ y: [0, 6, 0] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
          />
        </div>
      </motion.div>
    </section>
  )
}
